import React from "react";
import { MultiColumnList } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
export var TitleNamesTable = function (_a) {
    var names = _a.names;
    return (React.createElement(MultiColumnList, { contentData: names, columnMapping: {
            type: React.createElement(FormattedMessage, { id: "ui-br-agency.title.names.type.label" }),
            name: React.createElement(FormattedMessage, { id: "ui-br-agency.title.names.name.label" }),
            prefix: React.createElement(FormattedMessage, { id: "ui-br-agency.title.names.prefix.label" }),
            titleWithoutPrefix: (React.createElement(FormattedMessage, { id: "ui-br-agency.title.names.titleWithoutPrefix.label" })),
            partNumber: (React.createElement(FormattedMessage, { id: "ui-br-agency.title.names.partNumber.label" })),
            partName: (React.createElement(FormattedMessage, { id: "ui-br-agency.title.names.partName.label" })),
            subtitle: (React.createElement(FormattedMessage, { id: "ui-br-agency.title.names.subtitle.label" })),
        }, formatter: {
            type: function (item) { var _a; return ((_a = item.type) === null || _a === void 0 ? void 0 : _a.description) || "-"; },
            name: function (item) { return item.name || "-"; },
            prefix: function (item) { return item.prefix || "-"; },
            titleWithoutPrefix: function (item) { return item.titleWithoutPrefix || "-"; },
            partNumber: function (item) { return item.partNumber || "-"; },
            partName: function (item) { return item.partName || "-"; },
            subtitle: function (item) { return item.subtitle || "-"; },
        }, visibleColumns: [
            "type",
            "name",
            "prefix",
            "titleWithoutPrefix",
            "partNumber",
            "partName",
            "subtitle",
        ], isEmptyMessage: React.createElement(FormattedMessage, { id: "ui-br-agency.table.empty" }), interactive: false }));
};
